import { useQuery } from "react-query";
import { getDoorContact } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useDoorContact = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetDoorContact",
    getDoorContact,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
